import graphqlClient from '~/graphql/graphqlClient';
import { MutationClaimReferralCodeArgs, ClaimReferralCodeResult } from 'dt-common/generated/graphql-types';

const mutation = `
mutation ClaimReferralCode($playerId: String!, $code: String!) {
  claimReferralCode(playerId: $playerId, code: $code) {
    claim_reward
  }
}
`;

export default async function mutationClaimReferralCode(args: MutationClaimReferralCodeArgs) {
  return await graphqlClient.request<ClaimReferralCodeResult>('claimReferralCode', mutation, args);
}
